import './Footer.css'

const Footer = () => (
    <footer className='footer'>
        <a
            href='https://github.com/aakash-sony/my_portfolio'
            className='link footer__link'
        >
            Created By Akash Soni
        </a>
    </footer>
)

export default Footer

